import React, { ChangeEvent, Component, SyntheticEvent, useContext, useEffect, useState } from 'react';
import './ManagePermissionsScreen.css'

const ManagePermissionsScreen = () => {
    return (
        <div>Manage Permissions</div>
    );
}

export default ManagePermissionsScreen;